import { useMutation, useQueryClient } from '@tanstack/react-query';

type UpdateOrganizationPlanParams = {
  organizationId: number;
  planId: number;
  startDate: string;
  endDate: string;
  memberCounts: number | null;
};

export default function useUpdateAdminOrganizationPlan() {
  const queryClient = useQueryClient();
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement | undefined)
    ?.content;

  return useMutation({
    mutationFn: async (params: UpdateOrganizationPlanParams) => {
      const response = await fetch(`/admin/api/organizations/${params.organizationId}/plan`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token || '',
        },
        body: JSON.stringify({
          plan_id: params.planId,
          start_date: params.startDate,
          end_date: params.endDate,
          member_counts: params.memberCounts,
        }),
      });
      if (!response.ok) {
        throw new Error('プラン情報の更新に失敗しました');
      }
      return await response.json();
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'organizations'] });
      queryClient.invalidateQueries({
        queryKey: ['admin', 'organizations', variables.organizationId],
      });
    },
  });
}
